import React from 'react';
import {Grid} from '@albert-io/atomic';

export default class CoppaMessage extends React.Component<React.PropsWithChildren<{}>> {
  render() {
    return (
      <Grid.Container>
        <Grid.Row justify='center'>
          <Grid.Col xs={12} all={6} className='coppa-message'>
            <div className='rounded-x1 border border-solid border-border-primary background-primary p-x3'>
              {this.props.children}
            </div>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    );
  }
}
